import { ETourId, type ITourConfig } from '../types';

/**
 * Tour shown on the Guidance Center page.
 *
 * Three steps defined, but only two are shown at a time via stepConditions:
 * 1. Monitor automations — the insights section (always shown)
 * 2. Your action queue — shown when action items exist
 * 3. No action items for now — shown when no action items exist
 */
export const guidanceCenterTour: ITourConfig = {
  id: ETourId.GUIDANCE_CENTER,
  // gc-action-queue and gc-no-action-items are mutually exclusive at runtime
  chapterStepCount: 2,
  steps: [
    {
      id: 'gc-insights',
      target: '[data-tour-id="guidance-center-insights-section"]',
      titleKey: 'tours.guidanceCenter.insights.title',
      descriptionKey: 'tours.guidanceCenter.insights.description',
      position: 'bottomLeft',
    },
    {
      id: 'gc-action-queue',
      target: '[data-tour-id="guidance-center-action-items-section"]',
      titleKey: 'tours.guidanceCenter.actionQueue.title',
      descriptionKey: 'tours.guidanceCenter.actionQueue.description',
      finishLabelKey: 'tours.guidanceCenter.actionQueue.finishLabel',
      position: 'topLeft',
    },
    {
      id: 'gc-no-action-items',
      target: '[data-tour-id="guidance-center-action-items-section"]',
      titleKey: 'tours.guidanceCenter.noActionItems.title',
      descriptionKey: 'tours.guidanceCenter.noActionItems.description',
      finishLabelKey: 'tours.guidanceCenter.noActionItems.finishLabel',
      position: 'topLeft',
    },
  ],
  namespace: 'tours',
  variant: 'default',
  size: 'sm',
  analytics: {
    enabled: true,
    eventPrefix: 'tour_guidance_center',
    metadata: {
      tourName: 'Guidance Center',
    },
  },
  persistence: {
    strategy: 'localStorage',
  },
};
